exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".messages-example h1 {\n  background-color: purple\n}\n\n.note-dialog .modal-dialog{ z-index:1050; }\n\n.modal-backdrop, .modal-backdrop.in{\n  display: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/messages/public/assets/css/messages.css
// module id = 883
// module chunks = 0